import type { AccountSummary, HolisticCategory } from '@fruitful/types';

import { requestBuilder } from '../../../../http/RequestBuilder';
import { useRefetchHolisticSummaryMutationOptions } from '../useRefetchHolisticSummaryMutationOptions';

interface UpsertSpinwheelCreditCardAccountBody {
    id?: string;
    displayName?: string;
    userId?: string;
    holisticCategory?: HolisticCategory;
    accountRating?: string | null;
    minimumPaymentAmountCents?: number;
    interestRate?: number | null;
    description?: string;
    isHidden?: boolean;
}

const useUpsertSpinwheelCreditCardAccount = requestBuilder.mutation<
    AccountSummary,
    UpsertSpinwheelCreditCardAccountBody
>({
    endpoint: '/api/admin/holistic/accounts/spinwheel/credit-card',
    method: 'PATCH',
});

export const useUpsertSpinwheelCreditCardAccountAndRefetch = (
    membershipId: string | null,
) => {
    const refetchHolisticSummaryMutationOptions =
        useRefetchHolisticSummaryMutationOptions(membershipId);

    const { mutateAsync } = useUpsertSpinwheelCreditCardAccount(
        refetchHolisticSummaryMutationOptions,
    );

    const upsertSpinwheelCreditCardAccountAsync = async (
        body: UpsertSpinwheelCreditCardAccountBody,
    ) => {
        return await mutateAsync({
            body,
        });
    };

    return {
        upsertSpinwheelCreditCardAccountAsync,
    };
};
